import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Overview from "./pages/Overview";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import CalendarPage from "./pages/Calendar";
import Team from "./pages/Team";
import ClientPortal from "./pages/ClientPortal";
import PortalOverview from "./pages/portal/Overview";
import PortalApprovals from "./pages/portal/Approvals";
import PortalCalendar from "./pages/portal/PortalCalendar";
import PortalAnalytics from "./pages/portal/Analytics";
import PortalRequests from "./pages/portal/Requests";
import PortalLibrary from "./pages/portal/Library";
import PortalStrategy from "./pages/portal/Strategy";
import PortalProjects from "./pages/portal/Projects";
import ClientLibrary from "./pages/ClientLibrary";
import ClientStrategy from "./pages/ClientStrategy";
import ClientConnections from "./pages/ClientConnections";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import MyWork from "./pages/MyWork";
import StandupOverview from "./pages/StandupOverview";
import Leads from "./pages/Leads";
import LeadDetail from "./pages/LeadDetail";
import ClientTimeline from "./pages/ClientTimeline";
import { ConfirmProvider } from "./components/ConfirmProvider";
import ConnectInvite from "./pages/ConnectInvite";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProjectCosts from "./pages/ProjectCosts";

function Guard({ children, allow }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-neutral-500 font-mono text-xs uppercase tracking-widest">Loading…</div>;
  if (!user) return <Navigate to="/login" replace/>;
  if (allow === "team" && user.role === "client") return <Navigate to="/portal" replace/>;
  if (allow === "client" && user.role !== "client") return <Navigate to="/" replace/>;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login/>} />
      <Route path="/forgot-password" element={<ForgotPassword/>} />
      <Route path="/reset-password/:token" element={<ResetPassword/>} />
      <Route path="/connect/:token" element={<ConnectInvite/>} />
      <Route path="/portal" element={<Guard allow="client"><ClientPortal/></Guard>}>
        <Route index element={<PortalOverview/>} />
        <Route path="approvals" element={<PortalApprovals/>} />
        <Route path="calendar" element={<PortalCalendar/>} />
        <Route path="analytics" element={<PortalAnalytics/>} />
        <Route path="requests" element={<PortalRequests/>} />
        <Route path="library" element={<PortalLibrary/>} />
        <Route path="strategy" element={<PortalStrategy/>} />
        <Route path="projects" element={<PortalProjects/>} />
      </Route>
      <Route path="/" element={<Guard allow="team"><Layout/></Guard>}>
        <Route index element={<Overview/>} />
        <Route path="my-work" element={<MyWork/>} />
        <Route path="clients" element={<Clients/>} />
        <Route path="clients/:id" element={<ClientDetail/>} />
        <Route path="clients/:id/library" element={<ClientLibrary/>} />
        <Route path="clients/:id/strategy" element={<ClientStrategy/>} />
        <Route path="clients/:id/connections" element={<ClientConnections/>} />
        <Route path="calendar" element={<CalendarPage/>} />
        <Route path="projects" element={<Projects/>} />
        <Route path="standups" element={<StandupOverview/>} />
        <Route path="project-costs" element={<ProjectCosts/>} />
        <Route path="projects/:id" element={<ProjectDetail/>} />
        <Route path="leads" element={<Leads/>} />
        <Route path="leads/:id" element={<LeadDetail/>} />
        <Route path="clients/:id/timeline" element={<ClientTimeline/>} />
        <Route path="team" element={<Team/>} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ConfirmProvider>
            <AppRoutes/>
          </ConfirmProvider>
          <Toaster theme="dark" position="top-right" toastOptions={{style: {background:"#FFFFFF", border:"1px solid #E4E7EC", color:"#0F1729"}}}/>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
